if (!customElements.get('crc-hero-video')) {
  class CrcHeroVideo extends HTMLElement {
    connectedCallback() {
      this.template = this.querySelector('[data-crc-hero-video-template]');
      this.minWidth = Number.parseInt(this.dataset.minWidth || '768', 10);
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.desktopQuery = window.matchMedia(`(min-width: ${this.minWidth}px)`);

      if (this.canPlay()) {
        this.hydrate();
      }
    }

    canPlay() {
      const saveData = Boolean(navigator.connection?.saveData);
      return this.template && this.desktopQuery.matches && !this.motionQuery.matches && !saveData;
    }

    hydrate() {
      if (this.video || !this.canPlay()) return;

      const fragment = this.template.content.cloneNode(true);
      this.video = fragment.querySelector('video');
      if (!this.video) return;

      this.video.preload = 'metadata';
      this.append(fragment);
      this.video.play().catch(() => {
        this.video.remove();
        this.video = null;
      });
    }
  }

  customElements.define('crc-hero-video', CrcHeroVideo);
}
